module.exports = "\n<div data-component=\"report-income-list\" class=\"step\" *ngIf=\"active\">\n  <ul class=\"years\">\n    <li *ngFor=\"let year of yearsList\" (click)=\"getReportIncome(year)\">\n      {{year}}\n      <i class=\"item-arrow material-icons secondaryColor\">&#xE315;</i>\n    </li>\n  </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/report-income/report-income-list/report-income-list.component.html
// module id = ../../../../../src/app/master/report-income/report-income-list/report-income-list.component.html
// module chunks = main